"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault"),
    _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _onEnterPressed = _interopRequireDefault(require("@devsta/on-enter-pressed")),
    _classnames = _interopRequireDefault(require("classnames")),
    _Icon = _interopRequireDefault(require("../../Icon")),
    _Text = _interopRequireDefault(require("../../Text")),
    _InitialsPlaceholder = _interopRequireDefault(require("./InitialsPlaceholder")),
    _image = require("../styles/image");

require("../styles/_image.scss");

function Image(a) {
  var b = a.imageUrl,
      c = a.defaultImageIcon,
      d = a.placeholderText,
      e = a.placeholderTextSize,
      f = a.width,
      g = a.height,
      h = a.onClick,
      i = a.editButtonTitle,
      j = a.circular,
      k = a.rounded,
      l = a.isEditableImage,
      m = a.backgroundPosition,
      n = a.backgroundSize,
      o = a.defaultIconColour,
      p = a.defaultIconBackground,
      q = a.defaultIconSize,
      r = a.defaultIconSubtitle,
      s = a.defaultIconAnimated,
      t = a.imageElement;

  if (t) {
    return _react["default"].createElement("picture", null, _react["default"].createElement("source", {
      srcSet: "".concat(t.sourceUrl, ".webp"),
      type: "image/webp"
    }), _react["default"].createElement("source", {
      srcSet: "".concat(t.sourceUrl, ".").concat(t.sourceExtension),
      type: "image/".concat(t.sourceExtension)
    }), _react["default"].createElement("img", {
      style: {
        width: f,
        height: g,
        minWidth: f,
        objectFit: n,
        objectPosition: m
      },
      alt: t.alt,
      loading: "lazy",
      className: (0, _classnames["default"])("image", (0, _image.IMAGE)({
        clickable: !!h,
        circular: j,
        rounded: k
      }), {
        "image--clickable": !!h,
        "image--circular": j
      }),
      src: t.sourceUrl,
      onClick: h,
      onKeyDown: (0, _onEnterPressed["default"])({
        onClick: h
      }),
      role: "button",
      tabIndex: h ? 0 : void 0
    }));
  }

  var u = d && d.trim() ? _react["default"].createElement(_InitialsPlaceholder["default"], {
    string: d,
    size: g,
    fontSize: e
  }) : _react["default"].createElement("div", {
    className: (0, _classnames["default"])("image__icon", (0, _image.IMAGE_ICON)({
      background: p,
      width: f,
      height: g,
      defaultIconSize: q,
      color: o,
      hasSubtitle: !!r
    }))
  }, _react["default"].createElement(_Icon["default"], {
    name: c,
    color: o,
    size: q,
    animated: s
  }), r ? _react["default"].createElement(_Text["default"], {
    centered: !0,
    noMargin: "bottom",
    label: !0,
    className: "image__icon__subtitle"
  }, r) : null),
      v = {
    backgroundImage: b && "url(".concat(b, ")"),
    width: f,
    height: g,
    minWidth: f,
    backgroundPosition: m,
    backgroundSize: j ? "cover" : n
  };
  return _react["default"].createElement("div", {
    onClick: h,
    onKeyDown: (0, _onEnterPressed["default"])({
      onClick: h
    }),
    className: (0, _classnames["default"])("image", (0, _image.IMAGE)({
      clickable: !!h,
      circular: j,
      rounded: k
    }), {
      "image--clickable": !!h,
      "image--circular": j
    }),
    role: "button",
    tabIndex: h ? 0 : void 0,
    style: v
  }, b ? null : u, !!h && l ? _react["default"].createElement("div", {
    className: (0, _classnames["default"])("image__edit", _image.IMAGE_EDIT)
  }, _react["default"].createElement(_Icon["default"], {
    name: "camera",
    color: "white",
    size: 12
  }), _react["default"].createElement("p", null, i)) : null);
}

Image.defaultProps = {
  defaultImageIcon: "organisation",
  width: "100px",
  height: "100px",
  editButtonTitle: "Edit",
  backgroundPosition: "center",
  backgroundSize: "contain",
  defaultIconColour: "white",
  defaultIconBackground: "parthenon"
};

var _default = (0, _react.memo)(Image);

exports["default"] = _default;